import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "85",
  height: "52",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "currentColor",
      "fill-rule": "nonzero"
    }, [
      _createElementVNode("path", { d: "M84.6.4H.4v19.58h84.2V.4Zm-3.2 3.2v13.179H3.6V3.6h77.8Z" }),
      _createElementVNode("path", { d: "M75.807 18.38V51h-3.2V18.38zM12.647 18.38V51h-3.2V18.38zM82.435.504l1.13 2.994-43.422 16.38-1.13-2.994z" })
    ], -1)
  ])))
}
export default { render: render }